var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company_settings_realworks_credentials bg-white rounded-lg"},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }